import { styled } from '@linaria/react';

import { ChevronIcon } from '../../assets/vectors';

const ChevronStyled = styled(ChevronIcon)`
  transition: transform 0.25s ease;
  transform-origin: center;

  [aria-expanded='true'] & {
    transform: rotate(-180deg);
  }
`;

interface ChevronProps {
  expanded: boolean;
  strokeWidth?: number;
  width?: number;
}

export const Chevron = ({ expanded, strokeWidth, width, ...props }: ChevronProps) => (
  <ChevronStyled aria-expanded={expanded} strokeWidth={strokeWidth} width={width} {...props} />
);
